export const SET_APP_LOCATION = 'SET_APP_LOCATION'